import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
const Oferta = () => {
  useEffect(() => {
    document.title = 'Oferta - Kwiecińscy Zakład Mięsny';
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="oferta-section">
      <div className="oferta-header container">
        <h2>OFERTA</h2>
        <p className="my-4">
          W naszej rozległej ofercie znajdziesz różnorodne i wysokiej jakości
          produkty mięsne, które spełnią oczekiwania nawet najbardziej
          wymagających smakoszy. Od świeżego drobiu po wykwintne wędliny, nasze
          bogate menu zachwyci Cię różnorodnością i doskonałym smakiem.
        </p>
      </div>
      <div className="oferta-container container">
        <div className="row-1">
          <article className="wedliny">
            <Link to={'/oferta/wedliny'} className="img-holder" />
            <span>
              <h3>Wędliny</h3>
              <Link
                to="/oferta/wedliny"
                className="bg-[#119e3b] hover:bg-[#12351d] transition-colors  px-2 py-1 text-white text-lg rounded-full"
              >
                ZOBACZ WIĘCEJ
              </Link>
            </span>
          </article>
          <article className="wieprzowe">
            <Link to={'/oferta/wieprzowina'} className="img-holder" />
            <span>
              <h3>Mięso wieprzowe</h3>
              <Link
                to="/oferta/wieprzowina"
                className="bg-[#119e3b] hover:bg-[#12351d] transition-colors  px-2 py-1 text-white text-lg rounded-full"
              >
                ZOBACZ WIĘCEJ
              </Link>
            </span>
          </article>
          <article className="drob">
            <Link to={'/oferta/drob'} className="img-holder" />
            <span>
              <h3>Drób</h3>
              <Link
                to="/oferta/drob"
                className="bg-[#119e3b] hover:bg-[#12351d] transition-colors  px-2 py-1 text-white text-lg rounded-full"
              >
                ZOBACZ WIĘCEJ
              </Link>
            </span>
          </article>
        </div>
        <div className="row-2">
          <article className="oferta-gastronomiczna">
            <Link to={'/oferta/ofertagastronomiczna'} className="img-holder" />
            <span>
              <h3>Oferta gastronomiczna</h3>
              <Link
                to="/oferta/ofertagastronomiczna"
                className="bg-[#119e3b] hover:bg-[#12351d] transition-colors  px-2 py-1 text-white text-lg rounded-full"
              >
                ZOBACZ WIĘCEJ
              </Link>
            </span>
          </article>
          <article className="oferta-specjalna">
            <Link to={'/oferta/ofertaspecjalna'} className="img-holder" />
            <span>
              <h3>Oferta specjalna</h3>
              <Link
                to="/oferta/ofertaspecjalna"
                className="bg-[#119e3b] hover:bg-[#12351d] transition-colors  px-2 py-1 text-white text-lg rounded-full"
              >
                ZOBACZ WIĘCEJ
              </Link>
            </span>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Oferta;
